
export interface Country {
  countryValue: string;
  countryName: string;
  regions: Region[];
}

export interface Region {
  value: string;
  viewValue: string;
}


export const COUNTRIES = [
  {
    countryValue: 'US',
    countryName: 'United States',
    regions: [
      { value: 'AL', viewValue: 'Alabama' },
      { value: 'AK', viewValue: 'Alaska' },
      { value: 'AS', viewValue: 'American Samoa' },
      { value: 'AZ', viewValue: 'Arizona' },
      { value: 'AR', viewValue: 'Arkansas' },
      { value: 'CA', viewValue: 'California' },
      { value: 'CO', viewValue: 'Colorado' },
      { value: 'CT', viewValue: 'Connecticut' },
      { value: 'DE', viewValue: 'Delaware' },
      { value: 'DC', viewValue: 'District Of Columbia' },
      { value: 'FM', viewValue: 'Federated States Of Micronesia' },
      { value: 'FL', viewValue: 'Florida' },
      { value: 'GA', viewValue: 'Georgia' },
      { value: 'GU', viewValue: 'Guam' },
      { value: 'HI', viewValue: 'Hawaii' },
      { value: 'ID', viewValue: 'Idaho' },
      { value: 'IL', viewValue: 'Illinois' },
      { value: 'IN', viewValue: 'Indiana' },
      { value: 'IA', viewValue: 'Iowa' },
      { value: 'KS', viewValue: 'Kansas' },
      { value: 'KY', viewValue: 'Kentucky' },
      { value: 'LA', viewValue: 'Louisiana' },
      { value: 'ME', viewValue: 'Maine' },
      { value: 'MH', viewValue: 'Marshall Islands' },
      { value: 'MD', viewValue: 'Maryland' },
      { value: 'MA', viewValue: 'Massachusetts' },
      { value: 'MI', viewValue: 'Michigan' },
      { value: 'MN', viewValue: 'Minnesota' },
      { value: 'MS', viewValue: 'Mississippi' },
      { value: 'MO', viewValue: 'Missouri' },
      { value: 'MT', viewValue: 'Montana' },
      { value: 'NE', viewValue: 'Nebraska' },
      { value: 'NV', viewValue: 'Nevada' },
      { value: 'NH', viewValue: 'New Hampshire' },
      { value: 'NJ', viewValue: 'New Jersey' },
      { value: 'NM', viewValue: 'New Mexico' },
      { value: 'NY', viewValue: 'New York' },
      { value: 'NC', viewValue: 'North Carolina' },
      { value: 'ND', viewValue: 'North Dakota' },
      { value: 'MP', viewValue: 'Northern Mariana Islands' },
      { value: 'OH', viewValue: 'Ohio' },
      { value: 'OK', viewValue: 'Oklahoma' },
      { value: 'OR', viewValue: 'Oregon' },
      { value: 'PW', viewValue: 'Palau' },
      { value: 'PA', viewValue: 'Pennsylvania' },
      { value: 'PR', viewValue: 'Puerto Rico' },
      { value: 'RI', viewValue: 'Rhode Island' },
      { value: 'SC', viewValue: 'South Carolina' },
      { value: 'SD', viewValue: 'South Dakota' },
      { value: 'TN', viewValue: 'Tennessee' },
      { value: 'TX', viewValue: 'Texas' },
      { value: 'UT', viewValue: 'Utah' },
      { value: 'VT', viewValue: 'Vermont' },
      { value: 'VI', viewValue: 'Virgin Islands' },
      { value: 'VA', viewValue: 'Virginia' },
      { value: 'WA', viewValue: 'Washington' },
      { value: 'WV', viewValue: 'West Virginia' },
      { value: 'WI', viewValue: 'Wisconsin' },
      { value: 'WY', viewValue: 'Wyoming' }
    ]
  },
  {
    countryValue: 'CA',
    countryName: 'Canada',
    regions: [
      {
        viewValue: 'Alberta',
        value: 'AB'
      },
      {
        viewValue: 'British Columbia',
        value: 'BC'
      },
      {
        viewValue: 'Manitoba',
        value: 'MB'
      },
      {
        viewValue: 'New Brunswick',
        value: 'NB'
      },
      {
        viewValue: 'Newfoundland and Labrador',
        value: 'NL'
      },
      {
        viewValue: 'Northwest Territories',
        value: 'NT'
      },
      {
        viewValue: 'Nova Scotia',
        value: 'NS'
      },
      {
        viewValue: 'Nunavut',
        value: 'NU'
      },
      {
        viewValue: 'Ontario',
        value: 'ON'
      },
      {
        viewValue: 'Prince Edward Island',
        value: 'PE'
      },
      {
        viewValue: 'Quebec',
        value: 'QC'
      },
      {
        viewValue: 'Saskatchewan',
        value: 'SK'
      },
      {
        viewValue: 'Yukon Territory',
        value: 'YT'
      }
    ]
  },
  {
    countryValue: 'MX',
    countryName: 'Mexico',
    regions: [
      {
        viewValue: 'Distrito Federal',
        value: 'DIF'
      },
      {
        viewValue: 'Aguascalientes',
        value: 'AGU'
      },
      {
        viewValue: 'Baja California',
        value: 'BCN'
      },
      {
        viewValue: 'Baja California Sur',
        value: 'BCS'
      },
      {
        viewValue: 'Campeche',
        value: 'CAM'
      },
      {
        viewValue: 'Chiapas',
        value: 'CHP'
      },
      {
        viewValue: 'Chihuahua',
        value: 'CHH'
      },
      {
        viewValue: 'Coahuila',
        value: 'COA'
      },
      {
        viewValue: 'Colima',
        value: 'COL'
      },
      {
        viewValue: 'Durango',
        value: 'DUR'
      },
      {
        viewValue: 'Guanajuato',
        value: 'GUA'
      },
      {
        viewValue: 'Guerrero',
        value: 'GRO'
      },
      {
        viewValue: 'Hidalgo',
        value: 'HID'
      },
      {
        viewValue: 'Jalisco',
        value: 'JAL'
      },
      {
        viewValue: 'Michoacán',
        value: 'MIC'
      },
      {
        viewValue: 'Morelos',
        value: 'MOR'
      },
      {
        viewValue: 'México',
        value: 'MEX'
      },
      {
        viewValue: 'Nayarit',
        value: 'NAY'
      },
      {
        viewValue: 'Nuevo León',
        value: 'NLE'
      },
      {
        viewValue: 'Oaxaca',
        value: 'OAX'
      },
      {
        viewValue: 'Puebla',
        value: 'PUE'
      },
      {
        viewValue: 'Querétaro',
        value: 'QUE'
      },
      {
        viewValue: 'Quintana Roo',
        value: 'ROO'
      },
      {
        viewValue: 'San Luis Potosí',
        value: 'SLP'
      },
      {
        viewValue: 'Sinaloa',
        value: 'SIN'
      },
      {
        viewValue: 'Sonora',
        value: 'SON'
      },
      {
        viewValue: 'Tabasco',
        value: 'TAB'
      },
      {
        viewValue: 'Tamaulipas',
        value: 'TAM'
      },
      {
        viewValue: 'Tlaxcala',
        value: 'TLA'
      },
      {
        viewValue: 'Veracruz',
        value: 'VER'
      },
      {
        viewValue: 'Yucatán',
        value: 'YUC'
      },
      {
        viewValue: 'Zacatecas',
        value: 'ZAC'
      }
    ]
  },
  {
    countryValue: 'BR',
    countryName: 'Brazil',
    regions: [
      {
        value: 'AC',
        viewValue: 'Acre'
      },
      {
        value: 'AL',
        viewValue: 'Alagoas'
      },
      {
        value: 'AM',
        viewValue: 'Amazonas'
      },
      {
        value: 'AP',
        viewValue: 'Amapá'
      },
      {
        value: 'BA',
        viewValue: 'Bahia'
      },
      {
        value: 'CE',
        viewValue: 'Ceará'
      },
      {
        value: 'DF',
        viewValue: 'Distrito Federal'
      },
      {
        value: 'ES',
        viewValue: 'Espírito Santo'
      },
      {
        value: 'GO',
        viewValue: 'Goiás'
      },
      {
        value: 'MA',
        viewValue: 'Maranhão'
      },
      {
        value: 'MG',
        viewValue: 'Minas Gerais'
      },
      {
        value: 'MS',
        viewValue: 'Mato Grosso do Sul'
      },
      {
        value: 'MT',
        viewValue: 'Mato Grosso'
      },
      {
        value: 'PA',
        viewValue: 'Pará'
      },
      {
        value: 'PB',
        viewValue: 'Paraíba'
      },
      {
        value: 'PE',
        viewValue: 'Pernambuco'
      },
      {
        value: 'PI',
        viewValue: 'Piauí'
      },
      {
        value: 'PR',
        viewValue: 'Paraná'
      },
      {
        value: 'RJ',
        viewValue: 'Rio de Janeiro'
      },
      {
        value: 'RN',
        viewValue: 'Rio Grande do Norte'
      },
      {
        value: 'RO',
        viewValue: 'Rondônia'
      },
      {
        value: 'RR',
        viewValue: 'Roraima'
      },
      {
        value: 'RS',
        viewValue: 'Rio Grande do Sul'
      },
      {
        value: 'SC',
        viewValue: 'Santa Catarina'
      },
      {
        value: 'SE',
        viewValue: 'Sergipe'
      },
      {
        value: 'SP',
        viewValue: 'São Paulo'
      },
      {
        value: 'TO',
        viewValue: 'Tocantins'
      }
    ]
  },
  {
    countryValue: 'AT',
    countryName: 'Australia',
    regions: [
      {
        viewValue: 'New South Wales',
        value: 'NSW'
      },
      {
        viewValue: 'Victoria',
        value: 'VIC'
      },
      {
        viewValue: 'Queensland',
        value: 'QLD'
      },
      {
        viewValue: 'Tasmania',
        value: 'TAS'
      },
      {
        viewValue: 'South Australia',
        value: 'SA'
      },
      {
        viewValue: 'Western Australia',
        value: 'WA'
      },
      {
        viewValue: 'Northern Territory',
        value: 'NT'
      },
      {
        viewValue: 'Australian Capital Territory',
        value: 'ACT'
      }
    ]
  },
  {
    countryValue: 'IT',
    countryName: 'Italy',
    regions:

     [
      {
        value: 'ABR',
        viewValue: 'Abruzzo'
      },
      {
        value: 'BAS',
        viewValue: 'Basilicata'
      },
      {
        value: 'CAL',
        viewValue: 'Calabria'
      },
      {
        value: 'CAM',
        viewValue: 'Campania'
      },
      {
        value: 'EMI',
        viewValue: 'Emilia - Romagna'
      },
      {
        value: 'FRI',
        viewValue: 'Friuli - Venezia Giulia'
      },
      {
        value: 'LAZ',
        viewValue: 'Lazio'
      },
      {
        value: 'LIG',
        viewValue: 'Liguria'
      },
      {
        value: 'LOM',
        viewValue: 'Lombardia'
      },
      {
        value: 'MAR',
        viewValue: 'Marche'
      },
      {
        value: 'MOL',
        viewValue: 'Molise'
      },
      {
        value: 'PIE',
        viewValue: 'Piemonte'
      },
      {
        value: 'PUG',
        viewValue: 'Puglia'
      },
      {
        value: 'SAR',
        viewValue: 'Sardegna'
      },
      {
        value: 'SIC',
        viewValue: 'SiciliaTOS - Toscana'
      },
      {
        value: 'TRE',
        viewValue: 'Trentino-Alto Adige'
      },
      {
        value: 'UMB',
        viewValue: 'Umbria'
      },
      {
        value: 'VAL',
        viewValue: 'Valle D\'Aosta'
      },
      {
        value: 'VEN',
        viewValue: 'Veneto'
      }
    ]
  }
];
























